import React from 'react';
import styles from './AlertBanner.module.css';

type AlertVariant = 'error' | 'success' | 'warning';

interface AlertBannerProps {
  message: string;
  variant: AlertVariant;
  className?: string;
}

const AlertBanner: React.FC<AlertBannerProps> = ({
  message,
  variant,
  className = '',
}) => (
  <div className={`${styles.alert} ${styles[variant]} ${className}`}>
    {message}
  </div>
);

export default AlertBanner;
